import Chip from "./SelectChip.svelte"
import Chips from "./SelectChips.svelte"
import Content from "./SelectContent.svelte"
import Indicator from "./SelectIndicator.svelte"
import Input from "./SelectInput.svelte"
import Option from "./SelectOption.svelte"
import Panel from "./SelectPanel.svelte"
import Portal from "./SelectPortal.svelte"
import Root from "./SelectRoot.svelte"
import Trigger from "./SelectTrigger.svelte"

export const Select = {
  Root,
  Option,
  Panel,
  Portal,
  Trigger,
  Input,
  Indicator,
  Content,
  Chip,
  Chips,
}

export { getSelectRootContext, type SelectState } from "./SelectRoot.svelte"
